//import {Page} from './Page.js';
import { Newsletter } from './_newsletter';

class Main
{
	constructor ()
	{
		console.log( "%c Super Écran GO GO GO ", "background-color:#e92a24;color:#FFFFFF" );
		this.$popin        = $( '#popin' );
		this.$popinOverlay = $( '#popin_overlay' );
		this.$main         = $( 'main' );
		this.$body         = $( 'body' );
		this.$topBar       = $( '#topbar' );

		this.$questions = $( '#questions' ).find( 'dt' );

		this.$selectProviders   = $( '#providers' ).find( 'select' );
		this.$providerInfo      = $( '#provider_info' );
		this.$providerInfoName  = $( '#provider_info' ).find( 'p.name' );
		this.$providerInfoPhone = $( '#provider_info' ).find( 'p.phone' );

		this.bindEvents();
		//this.showPopinSubscription();


		this.$main.addClass( 'is-' + this.getPlatform() );
		this.$questions.addClass( 'is-closed' );
		this.$questions.siblings( 'dd' ).slideUp( 0 );

		let $sections = this.$main.find( 'section, footer' );
		$sections.addClass( 'is-invisible' );

		this.controller = new ScrollMagic.Controller();

		new ScrollMagic.Scene( {
			triggerElement : "#main_logo",
			triggerHook    : "onLeave",
		} )
			.setClassToggle( '#topbar', 'is-logo-visible' )
			.addTo( this.controller );

		$sections.each( function ( _i, _el )
		{
			let $el   = $( _el );
			let strId = $el.attr( 'id' );

			let scene = new ScrollMagic.Scene( {
				triggerElement : "#" + strId,
				triggerHook    : "onEnter",
				reverse        : false,
				offset         : 100,
			} )
				.addTo( this.controller );
			scene.on( 'enter', function ()
			{

				$el.removeClass( 'is-invisible' );
			} );
		}.bind( this ) );



		this.setupYouTubeVideo();
	}

	bindEvents ()
	{
		$( '#btn_subscribed' ).on( 'click', this.showSubscribedPage.bind( this ) );
		$( '#btn_not_subscribed' ).on( 'click', this.closePopin.bind( this ) );
		$( '#btn_providers' ).on( 'click', this.showPopinProviders.bind( this ) );
		$( '#btn_open_menu' ).on( 'click', this.showPopinMenu.bind( this ) );
		$( '#btn_close' ).on( 'click', this.closePopin.bind( this ) );
		this.$selectProviders.on( 'change', this.changeProvider.bind( this ) );
		$( '#providers' ).find( 'ul.main_providers li' ).on( 'click', this.changeProviderLogo.bind( this ) );
		this.$questions.on( 'click', this.toggleQuestionVisibility.bind( this ) );
		$( 'a.internal_link' ).on( 'click', this.goToElement.bind( this ) );
		$( '[data-gtag-event]' ).on( 'click', this.prepareGtagEvent.bind( this ) );



	}

	goToElement ( _e )
	{
		_e.preventDefault();

		let $this   = $( _e.currentTarget );
		let strHref = $this.attr( 'href' );

		console.log( $this, strHref );
		$( 'html, body' ).animate( {
			scrollTop : $( strHref ).offset().top - this.$topBar.height(),
		}, 500 );

		this.closePopin();

	}

	blockScroll ()
	{
		this.$body.addClass( 'is-no-scroll' );
	}

	unblockScroll ()
	{
		this.$body.removeClass( 'is-no-scroll' );
	}

	showPopinSubscription ()
	{
		this.blockScroll();
		this.$popin.removeClass().addClass( 'is-visible is-subscribe' );
		this.$popinOverlay.addClass( 'is-visible' );
	}

	showSubscribedPage ()
	{
		this.$main.addClass( 'is-user-subscribed' );
		this.closePopin();
	}

	showPopinProviders ( _e )
	{
		_e.preventDefault();
		this.blockScroll();
		this.$popin.removeClass().addClass( 'is-visible is-providers' );
		this.$popinOverlay.addClass( 'is-visible' );
		this.$selectProviders.select2();
	}

	showPopinMenu ( _e )
	{
		_e.preventDefault();
		this.blockScroll();
		this.$popin.removeClass().addClass( 'is-visible is-mobile-menu' );
		this.$popinOverlay.addClass( 'is-visible' );
	}

	closePopin ()
	{
		this.unblockScroll();
		this.$popin.removeClass( 'is-visible' );
		this.$popinOverlay.removeClass( 'is-visible' );
	}

	changeProvider ()
	{
		let strName  = this.$selectProviders.find( ':selected' ).text();
		let strPhone = this.$selectProviders.find( ':selected' ).val();
		if ( strPhone == '' )
		{
			strName = '';
		}

		this.$providerInfoName.text( strName );
		this.$providerInfoPhone.html( this.getPhoneLink( strPhone ) );

		this.prepareProviderListGtagEvent( strName );
	}

	changeProviderLogo ( _e )
	{
		let $el = $( _e.target );
		if ( !$el.is( 'li' ) )
		{
			$el = $el.parents( 'li' );
		}
		this.$providerInfoName.text( $el.attr( 'data-name' ) );
		this.$providerInfoPhone.html( this.getPhoneLink( $el.attr( 'data-phone' ) ) );
		this.prepareProviderLogoGtagEvent( $el );
	}

	getPlatform ()
	{
		let userAgent = navigator.userAgent || navigator.vendor || window.opera;

		if ( /android/i.test( userAgent ) )
		{
			return "android";
		}

		if ( /iPad|iPhone|iPod/.test( userAgent ) && !window.MSStream )
		{
			return "ios";
		}
		return "desktop";
	}

	toggleQuestionVisibility ( _e )
	{
		let $this = $( _e.target );

		if ( $this.hasClass( 'is-closed' ) )
		{
			$this.removeClass( 'is-closed' );
			$this.next( 'dd' ).stop().slideDown( 300 );
		} else
		{
			$this.addClass( 'is-closed' );
			$this.next( 'dd' ).stop().slideUp( 300 );
		}
	}

	prepareGtagEvent ( _e )
	{
		let $this = $( _e.target );
		if ( !$this.is( '[data-gtag-event]' ) )
		{
			$this = $this.parents( '[data-gtag-event]' );
		}
		this.sendGtagEvent( $this.attr( 'data-gtag-action' ), $this.attr( 'data-gtag-category' ), $this.attr( 'data-gtag-label' ) );
	}

	prepareProviderLogoGtagEvent ( _$el )
	{
		this.sendGtagEvent( 'Sélection télédistributeur', 'Télédistributeurs', _$el.attr( 'data-name' ) );
	}

	prepareProviderListGtagEvent ( _strName )
	{
		this.sendGtagEvent( 'Sélection télédistributeur', 'Télédistributeurs', _strName );
	}

	sendGtagEvent ( _strAction, _strCategory, _strLabel )
	{

		if ( typeof window.gtag === "function" )
		{
			window.gtag( 'event', _strAction, {
				'event_category' : _strCategory,
				'event_label'    : _strLabel,

			} );
		}
	}

	getPhoneLink ( _strPhone )
	{
		let strFormattedPhone = _strPhone.replace( /\D/g, '' );
		return '<a href="tel:' + strFormattedPhone + '">' + _strPhone + '</a>'
	}


	setupYouTubeVideo ()
	{

		const videoContainerId = 'youtube-player-container'

		const ytScriptTag = document.createElement( 'script' );
		ytScriptTag.src   = "https://www.youtube.com/iframe_api";

		const firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
		firstScriptTag.parentNode.insertBefore( ytScriptTag, firstScriptTag );

		this.ytPlayer = '';
this.firstPlay = true;

		window.onYouTubeIframeAPIReady = function ()
		{
			this.ytPlayer = new YT.Player( 'youtube-iframe', {

				playerVars : {
					'playsinline' : 1,
				},
				events     : {
					'onReady'       : ( e ) =>
					{
						// console.log( "YT Player is ready", e );
					},
					'onStateChange' : ( e ) =>
					{

						//https://developers.google.com/youtube/iframe_api_reference#Playback_status

						if( 1 !== e.data) {
							return;
						}

						// send a gtag event, but only the first time
						if(this.firstPlay) {
							if ( typeof window.gtag === "function" )
							{
								window.gtag( 'event', "Démarrer vidéo YouTube", {
									'event_category' : 'Navigation',
									'event_label'    : "Vidéo : " + this.ytPlayer.getVideoUrl(),

								} );
							}
						}

						this.firstPlay = false;

						// console.log( "YT Player state has changed", e );
					},
				},
			} );
		}.bind(this);
	}
}


$( function ()
{
	new Main();
	new Newsletter();
} );